import { Platform } from "react-native";
import { StyleSheet } from "react-native-unistyles";

import CustomPlatform from "$src/core/utils/platform/platform";

const stylesheet = StyleSheet.create(({ spacing }) => ({
  container: {
    width: "100%",
    height: "100%",
  },
  image: {
    ...StyleSheet.absoluteFill,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    opacity: 0.9,
  },
  inner: {
    justifyContent: "flex-end",
    paddingHorizontal: Platform.OS === "web" ? spacing(6) : 0,
    gap: spacing(2),
    height: "100%",
    paddingBottom: {
      xs: spacing(10),
      md: spacing(18),
    },
    width: {
      xs: "100%",
      md: CustomPlatform.select({
        tv: "100%",
        web: "40%",
      }),
      lg: CustomPlatform.select({
        tv: "100%",
        web: "100%",
      }),
    },
  },
  description: {
    paddingVertical: spacing(4),
    width: "50%",
    opacity: 0.8,
  },
  actions: {
    paddingVertical: spacing(4),
    flexDirection: "row",
    gap: spacing(4),
    width: "100%",
    maxWidth: "90%",
  },
  playButton: {
    flexShrink: 1,
    minWidth: 0,
  },
  infoButton: {
    flexShrink: 0,
  },
}));

export default stylesheet;
